// import React from "react";
import Card from "react-bootstrap/Card";
import React, { Fragment, useReducer } from "react";
import profile from "../../../images/profile/profile.jpg";
import { Link } from "react-router-dom";

const General = ({ customerById }) => {
  const { kyc_verified, display_name, email, phone, current_balance } = customerById;
  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item '>
            <Link to={"/customers"}>Customers</Link>
          </li>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Customer Details</Link>
          </li>
        </ol>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='profile card card-body px-3 pt-3 pb-0'>
            <div className='profile-head'>
              <div className='photo-content '>
                <div className='cover-photo rounded'></div>
              </div>
              <div className='profile-info'>
                <div className='profile-photo'>
                  <img src={profile} className='img-fluid rounded-circle' alt='profile' />
                </div>
                <div className='profile-details d-flex justify-content-between align-items-center'>
                  <div className='profile-name px-3 pt-2'>
                    <h4 className='text-muted mb-0'> Customer</h4>
                    <p className='text-center'>{display_name ? display_name : "--"}</p>
                  </div>
                  <div className='profile-email px-2 pt-2'>
                    <h4 className='text-muted mb-0'>Email </h4>
                    <p className='text-center'>{email ? email : "--"}</p>
                  </div>
                  <div className='profile-email px-2 pt-2'>
                    <h4 className='text-muted mb-0'>Phone</h4>
                    <p className='text-center'>{phone ? phone : ""}</p>
                  </div>
                  <div className='profile-email px-2 pt-2'>
                    <h4 className='text-muted mb-0'>KYC Status</h4>
                    <p
                      className='text-center'
                      style={{
                        color: kyc_verified ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {kyc_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                  <div className='profile-email px-2 pt-2'>
                    <h4 className='text-muted mb-0'>Gold Balance</h4>
                    <p className='text-primary fw-bold  text-center'>{current_balance ? current_balance : 0}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Card>
        <Card.Header>
          <div>
            <span className='fs-1 fw-bold text-capitalize' style={{ color: "#1A73E8" }}>
              Dhan gold
            </span>
          </div>

          <div className='d-flex flex-column'>
            <span>Gold Balance</span>
            <span className='fs-3 fw-bold'>0.569gms</span>
            <span>As of 2024-07-31</span>
          </div>
        </Card.Header>
        <Card.Body>
          <Card.Text className='w-75'>
            <div className='d-flex justify-content-between align-items-center'>
              <div>
                {" "}
                <span>Email Id</span> <br />
                <strong>c*******@gmail.com</strong>
              </div>
              <div>
                {" "}
                <span>Phone</span> <br />
                <strong>******4123</strong>
              </div>
              <div>
                {" "}
                <span>KYC</span> <br />
                <span className='fs-4 fw-bold' style={{ color: "red", background: "pink" }}>
                  Not Verified
                </span>
              </div>
            </div>
          </Card.Text>
        </Card.Body>
      </Card> */}
    </>
  );
};

export default General;
